// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"67":"d0d0711e","71":"ea5d74cc","150":"125f0367","224":"4c3c7ddc","362":"ff0d9993","446":"030fc7b1","450":"e2f0ecdc","483":"82626b73","498":"479a945a","635":"b82c3bcd","705":"5947ee1e","844":"0a4d3ffe","848":"664de4f8","876":"8c83fb00","888":"aee5073c","926":"43ce545c"}[chunkId] + ".js";
};